import type { RegistrationConfig } from '../types';
import { COMMON_REG_CONFIG } from './basic';

export const JUICYLVL_REG_CONFIG: RegistrationConfig = {
  ...COMMON_REG_CONFIG,
  buttons: {
    regButton: {
      colorMode: { primary: true },
    },
    googleRegButton: {
      colorMode: { blackTransparent: true },
    },
    next: {
      colorMode: { primary: true },
    },
    back: {
      colorMode: { blackTransparent: true },
    },
  },
  withNavigationOnFirstStep: false,
  withPayments: false,
};
